<template>
    <div class="footer-links">

        <div class="logo">
            <a href="/">
                <picture>
                    <img :src="logo" alt="Home">
                </picture>
            </a>
        </div>

        <div v-if="fields.disclaimer.value" class="footer-disclaimer" v-html="fields.disclaimer.value"></div>

        <nav>

            <ul v-if="hasALink()">

                <li v-if="fields['first-url'].value">
                    <a :href="fields['first-url'].value" :target="buildLinkTarget(fields['first-new-tab'])">
                        {{ fields['first-text'].value }}
                    </a>
                </li>

                <li v-if="fields['second-url'].value">
                    <a :href="fields['second-url'].value" :target="buildLinkTarget(fields['second-new-tab'])">
                        {{ fields['second-text'].value }}
                    </a>
                </li>

                <li v-if="fields['third-url'].value">
                    <a :href="fields['third-url'].value" :target="buildLinkTarget(fields['third-new-tab'])">
                        {{ fields['third-text'].value }}
                    </a>
                </li>

                <li v-if="fields['fourth-url'].value">
                    <a :href="fields['fourth-url'].value" :target="buildLinkTarget(fields['fourth-new-tab'])">
                        {{ fields['fourth-text'].value }}
                    </a>
                </li>

            </ul>

            <ul v-if="phone || email">
                <li v-if="phone">Tel: <a :href="buildPhoneUrl()" v-html="phone"></a></li>
                <li v-if="email">Email: <a :href="buildEmailUrl()" v-html="email"></a></li>
            </ul>

            <ul v-if="address">
                <li v-html="address"></li>
            </ul>

        </nav>

    </div>
</template>

<script>

    import ApiWidget from './ApiWidget';

    export default ApiWidget.extend({

        props: [
            'logo',
            'fields'
        ],

        data() {
            return {
                address: '',
                email: '',
                phone: ''
            }
        },

        methods: {

            async update(sites) {
                [].forEach.call(sites, site => {
                    if (site.site_id === this.parameters['site'].value) {
                        this.address = site.page_footer.address;
                        this.email = site.page_footer.email;
                        this.phone = site.page_footer.phone;
                    }
                });
            },

            hasALink() {
                return this.fields['first-url'].value
                    || this.fields['second-url'].value
                    || this.fields['third-url'].value
                    || this.fields['fourth-url'].value;
            },

            buildEmailUrl() {
                return 'mailto:' + this.email;
            },

            buildPhoneUrl() {
                return 'tel:' + this.phone;
            },

            buildLinkTarget(linkNewTab) {
                return linkNewTab.value === 'on' ? '_blank' : null;
            }

        }
    });

</script>
